import React, { useMemo } from 'react'
import { RenderItemProps } from './types'
import { View, Image, ActivityIndicator } from '@/components'
import { FeedTextOverlay } from '../molecules/TextOverlay'
import { TextBubble } from '../atoms/TextBubble'
import { DebugItem, FeedDimensions } from './shared'
import { Imaging } from '@/services'

export const FeedImage = (props: RenderItemProps) => {
  const { item, contentOverlay } = props

  const img = item?.post?.image

  const size = Imaging.useImageSize(img)

  const style = useMemo(() => {
    if (!size?.data) return {}

    return Imaging.getImageSizeStyle({
      size,
      maxHeight: FeedDimensions.HEIGHT,
      maxWidth: FeedDimensions.WIDTH,
      maxMobileHeight: FeedDimensions.HEIGHT_WITHOUT_SPACING,
      maxMobileWidth: FeedDimensions.WIDTH_WITHOUT_SPACING,
    })
  }, [size?.data])

  if (!size?.data) {
    return (
      <View variants={['center', 'flex']}>
        <View variants={['center', 'border-radius:rounded', 'bg:neutral1']}>
          <ActivityIndicator debugName='' />
        </View>
      </View>
    )
  }

  return (
    <>
      <DebugItem {...props} />

      {contentOverlay}

      <View variants={['fullWidth', 'fullHeight', 'center']}>
        <Image source={img} objectFit='contain' style={style} />
      </View>
    </>
  )
}
